export const deleteItemByField = <T extends Record<string, any>>(
  array: T[],
  findConfiguration: { [K in keyof T]?: T[K] },
): T[] => {
  const [field, value] = Object.entries(findConfiguration)[0];

  return array.filter((item) => item[field] !== value);
};
